import { render, staticRenderFns } from "./PricingGuidesLayout.vue?vue&type=template&id=06ad7f60&"
import script from "./PricingGuidesLayout.vue?vue&type=script&lang=js&"
export * from "./PricingGuidesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ad7f60')) {
      api.createRecord('06ad7f60', component.options)
    } else {
      api.reload('06ad7f60', component.options)
    }
    module.hot.accept("./PricingGuidesLayout.vue?vue&type=template&id=06ad7f60&", function () {
      api.rerender('06ad7f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/PricingGuidesLayout.vue"
export default component.exports